import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";

export default class Reportes_telmex{

    getBuscarPorUnidadEstatus(context,UNIDAD,ESTATUS){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/GetBuscarPorUnidadEstatus/" + UNIDAD + "/" + ESTATUS)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getBuscarEstatus(context,ESTATUS){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/GetBuscarPorEstatus/" + ESTATUS)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    getBuscarPorUnidad(context,UNIDAD){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/GetBuscarPorUnidad/" + UNIDAD)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }
    getReportes(context){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/getReportes")        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }
    getDetalleReporte(context,ID){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/getDetalleReporte/" + ID)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }
    getBuscarPorFolio(context,ID){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.get(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/getReportePorFolio/" + ID)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    addReporte(context,param){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/addReporte",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    addDetalleReporte(context,param){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/addDetalleReporte",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

    updateReporte(context,param){        
        var t = context     
        var controller = new Controller();
        return new Promise(function(resolve,reject){            
            apiClientToken.post(store.getters.getUrlServicios + "WCFReportes_telmex.svc/RestService/updateReporte",param)        
            .then(function(response){
                //console.log(response.data.data);
                resolve(controller.getData(context,response));
            })
            .catch(function(error){
              t.$toast.add({
                  severity:"error",
                  summary:"ERROR",
                  detail:"Error al obtener datos del servidor",
                  life: 3000
              });
              console.log(error);
              reject(error);
            })
        })
    }

}